export const MODEL_INPUT_LIMITS: Record<string, { maxInputs: number; inputPrefix: string }> = {
  'kwaivgi/kling-v1.6-pro': { maxInputs: 4, inputPrefix: 'reference_image' },
  'fal-ai/flux-2-pro': { maxInputs: 8, inputPrefix: 'image' },
  'fal-ai/flux-2-flex': { maxInputs: 8, inputPrefix: 'image' },
  hyper_3d_rodin: { maxInputs: 5, inputPrefix: 'image' },
  'fal-ai/hyper3d/rodin/v2': { maxInputs: 5, inputPrefix: 'image' },
  'fal-ai/nano-banana/edit': { maxInputs: 10, inputPrefix: 'image' },
  'fal-ai/nano-banana-2/edit': { maxInputs: 14, inputPrefix: 'image' },
  'fal-ai/flux-2-max/edit': { maxInputs: 8, inputPrefix: 'image' },
  reve: { maxInputs: 4, inputPrefix: 'reference_image' },
  'fal-ai/kling-video/o1/video-to-video/reference': { maxInputs: 4, inputPrefix: 'image' },
  'fal-ai/kling-video/o1/video-to-video/edit': { maxInputs: 4, inputPrefix: 'image' },
  'fal-ai/bytedance/seedream/v5/lite/edit': { maxInputs: 10, inputPrefix: 'image' },
  'bytedance/seedance-2.0/reference-to-video': { maxInputs: 10, inputPrefix: 'reference' },
  // Add more models here as needed:
  // 'another-model-name': { maxInputs: 6, inputPrefix: 'some_prefix' },
};
